import { useQueryParam } from '@composables/utils/useQueryParam';
import { usePageData } from '@composables/usePageData';
import { useEnvProps } from '@composables/useEnvProps';
import { toArray } from '@utils/commonUtils';

const uiConfigCommon = {
  title: 'PDP Dual Brand',
  killswitches: {
    marketPlaceEnabled: { description: 'Enables marketplace' },
    bossEnabled: { description: 'Enable BOSS' },
    enhanceSameDayDeliveryEnabled: { description: 'Enable SDD (same day delivery)' },
    inStoreCurbsidePickupEnabled: { description: 'Curbside pickup' },
    isNavDisabled: { description: 'Disables nav' },
    disablePriceByColors: { description: 'Disables price by colors for 3v testing' },
    isAutoTaggingEnabled: { description: 'Enable auto tagging for experimentation' },
    isDelayedTealiumEnabled: { description: 'Load tealium from js instead of index.template' },
    is3rdVariantEnabled: { description: 'Enable 3rd variant experiment to create more consolidated products' },
    isPDPEnhancementFEnabled: { description: 'Enable SalesFloorWidget within Product Details section' },
    isPDPEnhancementCEnabled: { description: 'Enable sponsoredItemTop component' },
    isPDPEnhancementIEnabled: { description: 'Redesign + Shoppable' },
    isPDPEnhancementREnabled: { description: 'Show Product Details in Drawer when click on show more' },
    isPDPEnhancementSEnabled: { description: 'Product Details Treatment Arm 2' },
    isShippingAndReturnsBadgeEnabled: { description: 'Show New Section of Shipping & Returns' },
  },
};
const uiConfigMcom = {
  title: 'PDP Mcom',
  killswitches: {
    isTrueFitModalEnabled: { description: 'Enables true fit for size' },
    isFindationEnabled: { description: 'Enables findation for color' },
    isLoyaltyPPCEnabled: { description: 'Enable PPC banner' },
    isConsolidatedMasterPageEnabled: { description: 'Enables consolidated pages' },
    isPDPEnhancementWEnabled: { description: 'Pros Zone B displays above Stylitics' },
    isPDPEnhancementBEnabled: { description: 'When true product engagement is hidden' },
    isPDPEnhancementUEnabled: { description: 'Pros Zone b lazy loading root margin' },
    isPDPEnhancementTEnabled: { description: 'Stylitics and Pros Zone B swap' },
  },
};
const uiConfigBcom = {
  title: 'PDP Bcom',
  killswitches: {
    isTrueFitModalEnabled: { description: 'Enables true fit for size' },
    marketPlaceEnabled: { description: 'Enables marketplace' },
    isLoyaltyPPCEnabled: { description: 'Enable PPC banner' },
    isPDPEnhancementUEnabled: { description: 'Pros Zone b lazy loading root margin' },
    isPDPEnhancementNEnabled: { description: 'Fix product description on bcom' },
  },
};

/**
 * TODO: Resolve Module Compatibility Issue
 * Current Issue: This function is duplicated in server/productParser.js.
 * Problem: It's used both on the server-side and client-side, leading to duplication as
 * the module systems are different (CommonJS for server, ES6 for client).
 *
 * parse string like "ksName-true,ksName2-false" to object
 * @param {string?} str
 * @returns {Killswitches}
 */
function killSwitchUrlStringToObj(str) {
  /** @type {Killswitches} */
  const obj = {};

  if (str) {
    str.split(',').forEach((ksItem) => {
      const [ksName, ksValue] = ksItem.split('-');
      obj[ksName] = ksValue === 'true';
    });
  }

  return obj;
}

/**
 *
 * @param {string} name
 * @param {boolean} val
 */
function setKillswitchInUrl(name, val) {
  /** @type {(str: string | null) => string} */
  const updateKsString = (str) => {
    const obj = killSwitchUrlStringToObj(str);

    obj[name] = val;

    return toArray(obj).map(({ key, value }) => `${key}-${value}`).join(',');
  };

  const ks = useQueryParam('ks');
  ks.value = updateKsString(ks.value);
}

export const useKillswitches = () => {
  /** @type {PageData} */
  const { killswitches = {} } = usePageData();
  const { isMcom } = useEnvProps();

  return {
    set: setKillswitchInUrl,
    killswitches,
    uiConfig: [
      uiConfigCommon,
      isMcom ? uiConfigMcom : uiConfigBcom,
    ],
  };
};

export default useKillswitches;
